import React from 'react';
// import clsx from 'clsx';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';

import {
  Divider,
  Grid,
  MenuItem,
  Typography,
  // FormControl,
  // FormGroup,
} from '@mui/material';
import {
} from '@mui/lab';
import {withStyles} from '@mui/styles';
import SearchIcon from '@mui/icons-material/Search';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import GetAppIcon from '@mui/icons-material/GetApp';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';

import {
  FlexGridColumnGroup,
} from '@grapecity/wijmo.react.grid';

// import {
//   getCodeFromGeneralPurposeMap,
// } from '../../../../common/common.js';
import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {commonOperations} from '../../../../reducks/common';
import {attachorderOperations} from '../../../../reducks/attachorder';
import MainContainer from '../../../organisms/MainContainer.js';
import {/* renderCheckbox,*/ renderTextField, renderSelect} from '../../../atoms/CustomPart.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
// import BackButton from '../../../atoms/Buttons/BackButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
// import * as validateRule from '../../../validateRule.js';
import PaperPart from '../../../atoms/PaperPart.js';
import withRouter from '../../../organisms/withRouter.js';
import {CellMaker} from '@grapecity/wijmo.grid.cellmaker';
import {setSessionObject} from '../../../../common/Session.js';
import CustomAccordion from '../../../molecules/Accordion.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import {Autocomplete} from '@mui/material';

const styles = (theme) => ({
  period: {
    lineHeight: 3.5,
    margin: '0 -8px 0 20px',
  },
});

const autoCompleteItems = [
  {senroMskn: '北（ｷﾀｶﾝ）', code: 'A00001'},
  {senroMskn: 'ﾐﾅﾐｶﾝ', code: 'A00002'},
  {senroMskn: '東（ﾋｶｼｶﾝ）', code: 'A00003'},
  {senroMskn: 'ﾆｼｶﾝ', code: 'A00004'},
  {senroMskn: '北（ｷﾀｶﾝ）１', code: 'A00005'},
];

/**
 * お客さま情報照会画面
 * 画面ID:SCZ1008
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    const _list = [
      {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
      {gmnName: GMN.CUSTOMER_INFO_LIST.name, href: ''},
    ];
    this.state = {
      buttonDisabled: true,
      buttonDisabled2: true,
      // tabIndex: 1,
      transitionList: _list,
      warningMessages: [],
    };

    this.gridRef = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.props.doSetReferenceMode(false);
      // FlexGridに初期値設定
      if (this.gridRef && this.gridRef.current) {
        // this.gridRef.current.setInitItems('1001', []);
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doClearOrderList();
    this.props.doClearOrder();
    // if (this.gridRef && this.gridRef.current) {
    //   this.gridRef.current.saveScreenState('1001', 'Id');
    //   this.gridRef.current.setItems(null);
    // }
  }

  /**
   * 検索処理
   */
  _searchOrder = async () => {
    // const {generalPurposeMap} = this.props;

    // this.setState({buttonDisabled: true});

    // // 検索条件
    // let wkData = {};
    // if (this.props.values) {
    //   wkData = JSON.parse(JSON.stringify(this.props.values));
    // }
    // wkData['OrderCategory__c'] = getCodeFromGeneralPurposeMap(generalPurposeMap, 'OrderCategory01', 2);
    // wkData['RecordType.DeveloperName'] = 'ProprietyJudgeOrder';
    // // 申込ステータスがなければ追加
    // if (!Object.hasOwnProperty.call(wkData, 'OrderStatus__c')) {
    //   wkData['OrderStatus__c'] = proprietyOrderStatus;
    // }

    // const appSortParams = {
    //   CreatedDate: -1,
    // };

    // if (this.props.hasOwnProperty('orderList')) {
    // // 申込テーブルからデータ取得
    // const response = await this.props.doGetOrderTypeList(
    //     wkData, orderListFields, appSortParams,
    //     'getAttachOrderList', [], '');
    // const errorCode = getErrorCode(response);
    // if (errorCode != API_CODE.SUCCESS) {
    //   this.props.doShowMessage({
    //     message: {
    //       id: 'CE0052',
    //       values: ['可否判定申込', '取得'],
    //     },
    //   });
    //   return false;
    // }

    // 件数超過エラー
    // const maxKensu = getDataFromGeneralPurposeMap(
    //     generalPurposeMap, 'DisplayMaxKensu1', 1).ValueNum1__c;
    // const dataLen = response.data.body.data ?
    //   response.data.body.data.length : 0;
    // if (dataLen >= maxKensu) {
    //   this.props.doShowMessage({
    //     message: 'CE0015',
    //   });
    // }

    // FlexGridに検索結果設定
    // if (this.gridRef && this.gridRef.current) {
    //   this.gridRef.current.setItems(this.props.orderList);
    // }
    // }
    // let values = this.props.values;
    // let _warningMessages = [];
    // if (!values.hasOwnProperty('sinseiId')) {

    // }
    // if (values === undefined) {
    //   let message1 = {
    //     id: 'BFY000017E',
    //     values: ['申請ID', ''],
    //   };
    //   _warningMessages.push(message1);
    //   let message2 = {
    //     id: 'BFY000017E',
    //     values: ['事業場', ''],
    //   };
    //   _warningMessages.push(message2);
    //   let message3 = {
    //     id: 'BFY000017E',
    //     values: ['作成日（自）', ''],
    //   };
    //   _warningMessages.push(message3);
    //   let message4 = {
    //     id: 'BFY000017E',
    //     values: ['作成日（至）', ''],
    //   };
    //   _warningMessages.push(message4);
    //   let message5 = {
    //     id: 'BFY000017E',
    //     values: ['ステータス', ''],
    //   };
    //   _warningMessages.push(message5);
    //   this.setState({
    //     warningMessages: _warningMessages,
    //   });
    //   return;
    // }

    // if (values.sinseiId == '') {
    //   let message = {
    //     id: 'BFE000261E',
    //     values: null,
    //   };
    //   _warningMessages.push(message);
    //   this.setState({
    //     warningMessages: _warningMessages,
    //   });
    //   return;
    // }
    const data =[
      {NWjigyosyo_code: '広島北', supplyPointNo: '51602025031401', customerNo: '190000012', customerName: 'ＭＤＫＳテスト１３　４５６７９００２３４', customerName_kana: '△△△△△', address: '○○○△△△□□□□□', sectionNo: '00001', contract_date: '2023/01/01', transfer_date: '2023/10/01', pole_number: '12345', chousaGyousyu: '寝たきり', chousaReason: '漏えい電流が1mA超過で未調査', hijikaCode: '非自家用', keiyakuZyoukyou: '契約中', service_menu: '電灯定額接続送電サービス'},
      {NWjigyosyo_code: '広島北', supplyPointNo: '51602025031401', customerNo: '190000012', customerName: 'ＭＤＫＳテスト１３　４５６７９００２３４', customerName_kana: '△△△△△', address: '○○○△△△□□□□□', sectionNo: '00001', contract_date: '2023/01/01', transfer_date: '2023/10/01', pole_number: '12345', chousaGyousyu: '寝たきり', chousaReason: '漏えい電流が1mA超過で未調査', hijikaCode: '非自家用', keiyakuZyoukyou: '契約中', service_menu: '電灯定額接続送電サービス'},
      {NWjigyosyo_code: '広島北', supplyPointNo: '51602025031401', customerNo: '190000012', customerName: 'ＭＤＫＳテスト１３　４５６７９００２３４', customerName_kana: '△△△△△', address: '○○○△△△□□□□□', sectionNo: '00001', contract_date: '2023/01/01', transfer_date: '2023/10/01', pole_number: '12345', chousaGyousyu: '寝たきり', chousaReason: '漏えい電流が1mA超過で未調査', hijikaCode: '非自家用', keiyakuZyoukyou: '契約中', service_menu: '電灯定額接続送電サービス'},
      {NWjigyosyo_code: '広島北', supplyPointNo: '51602025031401', customerNo: '190000012', customerName: 'ＭＤＫＳテスト１３　４５６７９００２３４', customerName_kana: '△△△△△', address: '○○○△△△□□□□□', sectionNo: '00001', contract_date: '2023/01/01', transfer_date: '2023/10/01', pole_number: '12345', chousaGyousyu: '寝たきり', chousaReason: '漏えい電流が1mA超過で未調査', hijikaCode: '非自家用', keiyakuZyoukyou: '契約中', service_menu: '電灯定額接続送電サービス'},
      {NWjigyosyo_code: '広島北', supplyPointNo: '51602025031401', customerNo: '190000012', customerName: 'ＭＤＫＳテスト１３　４５６７９００２３４', customerName_kana: '△△△△△', address: '○○○△△△□□□□□', sectionNo: '00001', contract_date: '2023/01/01', transfer_date: '2023/10/01', pole_number: '12345', chousaGyousyu: '寝たきり', chousaReason: '漏えい電流が1mA超過で未調査', hijikaCode: '非自家用', keiyakuZyoukyou: '契約中', service_menu: '電灯定額接続送電サービス'},
      {NWjigyosyo_code: '広島北', supplyPointNo: '51602025031401', customerNo: '190000012', customerName: 'ＭＤＫＳテスト１３　４５６７９００２３４', customerName_kana: '△△△△△', address: '○○○△△△□□□□□', sectionNo: '00001', contract_date: '2023/01/01', transfer_date: '2023/10/01', pole_number: '12345', chousaGyousyu: '寝たきり', chousaReason: '漏えい電流が1mA超過で未調査', hijikaCode: '非自家用', keiyakuZyoukyou: '契約中', service_menu: '電灯定額接続送電サービス'},
      {NWjigyosyo_code: '広島北', supplyPointNo: '51602025031401', customerNo: '190000012', customerName: 'ＭＤＫＳテスト１３　４５６７９００２３４', customerName_kana: '△△△△△', address: '○○○△△△□□□□□', sectionNo: '00001', contract_date: '2023/01/01', transfer_date: '2023/10/01', pole_number: '12345', chousaGyousyu: '寝たきり', chousaReason: '漏えい電流が1mA超過で未調査', hijikaCode: '非自家用', keiyakuZyoukyou: '契約中', service_menu: '電灯定額接続送電サービス'},
      {NWjigyosyo_code: '広島北', supplyPointNo: '51602025031401', customerNo: '190000012', customerName: 'ＭＤＫＳテスト１３　４５６７９００２３４', customerName_kana: '△△△△△', address: '○○○△△△□□□□□', sectionNo: '00001', contract_date: '2023/01/01', transfer_date: '2023/10/01', pole_number: '12345', chousaGyousyu: '寝たきり', chousaReason: '漏えい電流が1mA超過で未調査', hijikaCode: '非自家用', keiyakuZyoukyou: '契約中', service_menu: '電灯定額接続送電サービス'},
      {NWjigyosyo_code: '広島北', supplyPointNo: '51602025031401', customerNo: '190000012', customerName: 'ＭＤＫＳテスト１３　４５６７９００２３４', customerName_kana: '△△△△△', address: '○○○△△△□□□□□', sectionNo: '00001', contract_date: '2023/01/01', transfer_date: '2023/10/01', pole_number: '12345', chousaGyousyu: '寝たきり', chousaReason: '漏えい電流が1mA超過で未調査', hijikaCode: '非自家用', keiyakuZyoukyou: '契約中', service_menu: '電灯定額接続送電サービス'},
    ];

    this.gridRef.current.setItemsSource(data);
    return true;
  };

  /**
   * クリア処理
   */
  _reset = async () => {
    this.setState({buttonDisabled2: true, warningMessages: []});
    const values = this.props.values;
    console.log(values);
    await this.props.reset();
    let datas = {supplyPointNo: ''};
    this.props.doSetInitValues(datas);
    const data =[];
    this.gridRef.current.setItemsSource(data);
    return true;
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    // try {
    //   const result = await this._searchOrder();
    //   if (!result) {
    //     return;
    //   }
    //   // 検索結果が0件の場合、エラーダイアログ表示
    //   if (!this.props.hasOwnProperty('orderList') ||
    //     !this.props.orderList ||
    //     this.props.orderList.length <= 0 ) {
    //     this.props.doShowMessage({
    //       message: 'CE0016',
    //     });
    //   }
    // } catch (error) {
    //   this.props.doShowMessage({
    //     message: 'TKSCS00001S',
    //     action: () => {
    //       this.props.history.push('/login');
    //     },
    //   });
    // }
    // this.gridRef = {}
    this.setState({buttonDisabled2: false});
    this._searchOrder();
  };

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef && this.gridRef.current &&
        this.gridRef.current.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 表示ボタン押下時
   */
  doDisplayInfo = async () => {
    this.props.navigate(GMN_PATH.CUSTOMER_INFO_INFO);
  };

  /**
   * 一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'None',
      filterOn: true,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'SingleColumn',
      isDisplayCount: true,
      AddDeleteOn: false,
      style: {maxHeight: '300px', maxWidth: '100%', height: 'auto', width: 'auto'},
      isReadOnly: true,
      checkedFunction: this.checkStateUpdate,
    };

    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        <FlexGridColumnGroup binding="NWjigyosyo_code" header="NW事業所" dataType="String" width={120}/>
        <FlexGridColumnGroup
          binding="supplyPointNo"
          header="供給地点特定番号"
          cellTemplate={CellMaker.makeLink({
            click: (e, ctx) => {
              this.doEditLink(ctx.item.supplyPointNo);
            },
          })}
          dataType="String"
          width={170}/>
        <FlexGridColumnGroup binding="customerNo" header="ご契約番号" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="customerName" header="お客さま名" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="customerName_kana" header="お客さま名カナ" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="address" header="住所" dataType="String" width={200}/>
        <FlexGridColumnGroup binding="sectionNo" header="ブロック番号" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="contract_date" header="供給開始年月日" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="transfer_date" header="異動年月日" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="hijikaCode" header="調査管理区分" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="chousaGyousyu" header="調査業種" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="chousaReason" header="調査理由" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="pole_number" header="電柱番号" dataType="String" width={110}/>
        <FlexGridColumnGroup binding="keiyakuZyoukyou" header="契約状況" dataType="String" width={110}/>
        <FlexGridColumnGroup binding="service_menu" header="サービスメニュー" dataType="String" width={170}/>
        <FlexGridColumnGroup binding="previous_surveyyear" header="前回調査年度" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="next_surveyyear" header="次回調査年度" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="previous_surveycode" header="前回委託エリア" dataType="String" width={150}/>
        {/* <FlexGridColumnGroup binding="next_surveycode" header="次回委託エリア" dataType="String" width={150}/> */}
      </CustomFlexGrid>
    );
  }

  /**
   * 一覧リンククリック時
   * @param {*} supplyPointNo 申請ID
   */
  doEditLink = async (supplyPointNo) => {
    try {
      let params = {
        supplyPointNo,
        mod: 'U',
      };

      // お客さま情報詳細画面に遷移
      setSessionObject(GMN.CUSTOMER_INFO_INFO.id, params);
      this.props.navigate(GMN_PATH.CUSTOMER_INFO_INFO);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * ＮＷＣ変更イベント
   * @param {*} e イベント
   * @param {*} v 値
   */
  handleNwcChange = async (e, v) => {
    // let mstMap = this.state.mstMap;
    // ＮＷＣを変更するとフィーダコンボボックスをクリアする。

    this.props.change('senroCode', '10002H');
    // ＮＷＣを空を選択と、電気所、バンクNo、フィーダコンボボックスを非活性にする。
    // if (v === '') {
    //   this.setState({
    //     senroNameDisabled: true,
    //     hhdsMsDisabled: true,
    //     bankNoDisabled: true,
    //     feederNameDisabled: true,
    //     downloadBtnDisabled: true,
    //   });
    // } else {
    //   let hhdss =
    //   mstMap.hhdss.filter((data) => data.zgsyoCd === v);
    //   let senros = await this.getSenros(v);
    //   this.setState({
    //     senroNameDisabled: false,
    //     hhdsMsDisabled: false,
    //     bankNoDisabled: true,
    //     feederNameDisabled: true,
    //     hhdss: hhdss,
    //     senros: senros,
    //     downloadBtnDisabled: true,
    //   });
    // }
  };

  /**
   * 線路名カナ イベント
   * @param {*} e イベント
   * @param {*} v 値
   */
  handleSenroNameChange = async (e, v) => {
    // let senros =[];
    // const {values} = this.props;
    // if (e.target.value === '') {
    //   this.props.change('senroCode', '10002H');
    //   senros = await this.getSenros(values.jigyousyo);
    // } else {
    //   senros =
    //     this.state.senros.filter((data) => data.senroMskn === e.target.value);
    //   if (senros.length == 0) {
    //     this.props.change('senroCode', '');
    //     senros = await this.getSenros(values.jigyousyo);
    //   } else {
    //     this.props.change('senroCode', senros[0].senroCd);
    //   }
    // }
    // this.setState({
    //   downloadBtnDisabled: true,
    //   senros: senros,
    // });
    this.props.change('senroCode', '10001H');
    // this.props.change('dntNo1From', '00001');
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    const {
      handleSubmit,
    } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        <Grid key="CSVoutput" item>
          <PositiveButton
            id="CSVoutput"
            onClick={handleSubmit(this.CSVoutput)}
            variant="contained"
            startIcon={<GetAppIcon/>}
          >
            <span>CSV出力</span>
          </PositiveButton>
        </Grid>
      </Grid>
    );
  };

  /**
 * CSV出力クリック時
 */
  CSVoutput = async () => {
    try {
      // let params = {
      //   mod: 'I',
      // };
      // setSessionObject(GMN.INVESTIGATION_YEAR_COMPANY_INFO.id, params);
      // this.props.navigate(GMN_PATH.INVESTIGATION_YEAR_COMPANY_INFO);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    const {classes} = this.props;
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="NWjigyosyo_code" item xs={12} sm={2}>
            <Field
              id="NWjigyosyo_code"
              name="NWjigyosyo_code"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="NW事業所"
              fullWidth
              required={false}
              onChange={this.handleNwcChange}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
                shrink: true,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5160}>{'広島北'}</MenuItem>
              <MenuItem value={6120}>{'山口'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="supplyPointNo" item xs={12} sm={2}>
            <Field
              id="supplyPointNo"
              name="supplyPointNo"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="供給地点特定番号"
              fullWidth
              type="text"
              required={false}
              validate={[
                // validateRule.number,
                // validateRule.maxLength(22),
              ]}
            />
          </Grid>
          <Grid key="customerNo" item xs={12} sm={2}>
            <Field
              id="customerNo"
              name="customerNo"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="ご契約番号"
              fullWidth
              type="text"
              required={false}
              validate={[
                // validateRule.number,
                // validateRule.maxLength(22),
              ]}
            />
          </Grid>
          <Grid key="customerName" item xs={12} sm={2}>
            <Field
              id="customerName"
              name="customerName"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="お客さま名"
              fullWidth
              type="text"
              required={false}
              validate={[
                // validateRule.number,
                // validateRule.maxLength(22),
              ]}
            />
          </Grid>
          <Grid key="customerName_kana" item xs={12} sm={2}>
            <Field
              id="customerName_kana"
              name="customerName_kana"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="お客さま名カナ"
              fullWidth
              type="text"
              required={false}
              validate={[
                // validateRule.number,
                // validateRule.maxLength(22),
              ]}
            />
          </Grid>
        </Grid>

        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="contract_date_from" item xs={12} sm={1.86}>
            <Field
              id="contract_date_from"
              name="contract_date_from"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="供給開始年月日"
              fullWidth
              type="date"
              required={false}
              InputLabelProps={{
                shrink: true,
              }}
              validate={[
                // validateRule.number,
                // validateRule.maxLength(22),
              ]}
            />
          </Grid>
          <Typography className={classes.period}>～</Typography>
          <Grid key="contract_date_to" item xs={12} sm={1.86}>
            <Field
              id="contract_date_to"
              name="contract_date_to"
              // variant="standard"
              component={renderTextField}
              className="fields"
              // label="供給開始年月日"
              fullWidth
              type="date"
              required={false}
              InputLabelProps={{
                shrink: true,
              }}
              validate={[
                // validateRule.number,
                // validateRule.maxLength(22),
              ]}
            />
          </Grid>
          <Grid key="transfer_date_from" item xs={12} sm={1.86}>
            <Field
              id="transfer_date_from"
              name="transfer_date_from"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="異動年月日"
              fullWidth
              type="date"
              required={false}
              InputLabelProps={{
                shrink: true,
              }}
              validate={[
                // validateRule.number,
                // validateRule.maxLength(22),
              ]}
            />
          </Grid>
          <Typography className={classes.period}>～</Typography>
          <Grid key="transfer_date_to" item xs={12} sm={1.86}>
            <Field
              id="transfer_date_to"
              name="transfer_date_to"
              // variant="standard"
              component={renderTextField}
              className="fields"
              // label="異動年月日"
              fullWidth
              type="date"
              required={false}
              InputLabelProps={{
                shrink: true,
              }}
              validate={[
                // validateRule.number,
                // validateRule.maxLength(22),
              ]}
            />
          </Grid>
        </Grid>

        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="hijikaCode" item xs={12} sm={2}>
            <Field
              id="hijikaCode"
              name="hijikaCode"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査管理区分"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'非自家用'}</MenuItem>
              <MenuItem value={2}>{'高圧非自家(毎年調査)'}</MenuItem>
              <MenuItem value={3}>{'高圧非自家(隔年調査)'}</MenuItem>
              <MenuItem value={4}>{'低圧自家用'}</MenuItem>
              <MenuItem value={5}>{'調査拒否'}</MenuItem>
              <MenuItem value={6}>{'非自家の取消(自主的に自家用化)'}</MenuItem>
              <MenuItem value={7}>{'非自家の取消(増設50kW以上)'}</MenuItem>
              <MenuItem value={8}>{'非自家の取消(全使撤,低圧化)'}</MenuItem>
              <MenuItem value={9}>{'非自家の取消(その他)'}</MenuItem>
              <MenuItem value={10}>{'ＪＲ調査'}</MenuItem>
              <MenuItem value={11}>{'ＪＲ調査拒否'}</MenuItem>
              <MenuItem value={12}>{'ＮＴＴ拒否'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="chousaGyousyu" item xs={12} sm={2}>
            <Field
              id="chousaGyousyu"
              name="chousaGyousyu"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査業種"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'寝たきり'}</MenuItem>
              <MenuItem value={3}>{'プール'}</MenuItem>
              <MenuItem value={4}>{'浴場'}</MenuItem>
              <MenuItem value={5}>{'学校等'}</MenuItem>
              <MenuItem value={6}>{'病院等'}</MenuItem>
              <MenuItem value={7}>{'老人福祉'}</MenuItem>
              <MenuItem value={8}>{'重要文化財'}</MenuItem>
              <MenuItem value={9}>{'学校でかつプール施設'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="chousaReason" item xs={12} sm={2}>
            <Field
              id="chousaReason"
              name="chousaReason"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査理由"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'漏えい電流が1mA超過で未調査'}</MenuItem>
              <MenuItem value={2}>{'漏えい電流の測定不能'}</MenuItem>
              <MenuItem value={3}>{'調査理由の取消'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="keiyakuZyoukyou" item xs={12} sm={2}>
            <Field
              id="keiyakuZyoukyou"
              name="keiyakuZyoukyou"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="契約状況"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'契約中'}</MenuItem>
              <MenuItem value={2}>{'廃止中'}</MenuItem>
              <MenuItem value={3}>{'供給遮断中'}</MenuItem>
              <MenuItem value={4}>{'全使撤'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="service_menu" item xs={12} sm={3}>
            <Field
              id="service_menu"
              name="service_menu"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="サービスメニュー"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'電灯定額接続送電サービス'}</MenuItem>
              <MenuItem value={2}>{'電灯標準接続送電サービス'}</MenuItem>
              <MenuItem value={3}>{'電灯時間帯別接続送電サービス'}</MenuItem>
              <MenuItem value={4}>{'電灯従量接続送電サービス'}</MenuItem>
              <MenuItem value={1}>{'高圧標準接続送電サービス'}</MenuItem>
              <MenuItem value={2}>{'高圧時間帯別接続送電サービス'}</MenuItem>
              <MenuItem value={3}>{'高圧臨時接続送電サービス'}</MenuItem>
              <MenuItem value={4}>{'高圧従量接続送電サービス'}</MenuItem>
            </Field>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="blockNoToFrom" item xs={12} sm={1.86}>
            <Field
              id="blockNoToFrom"
              name="blockNoToFrom"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="ブロック番号"
              fullWidth
              type="text"
              required={false}
              validate={[
                // validateRule.number,
                // validateRule.maxLength(22),
              ]}
            />
          </Grid>
          <Typography className={classes.period}>～</Typography>
          <Grid key="blockNoTo" item xs={12} sm={1.86}>
            <Field
              id="blockNoTo"
              name="blockNoTo"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="ブロック番号"
              fullWidth
              type="text"
              required={false}
              validate={[
                // validateRule.maxLength(5),
              ]}
            />
          </Grid>
          <Grid key="previous_surveyyear" item xs={12} sm={1.5}>
            <Field
              id="previous_surveyyear"
              name="previous_surveyyear"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="前回調査年度"
              fullWidth
              type="text"
              required={false}
              validate={[
                // validateRule.number,
                // validateRule.maxLength(22),
              ]}
            />
          </Grid>
          <Grid key="next_surveyyear" item xs={12} sm={1.5}>
            <Field
              id="next_surveyyear"
              name="next_surveyyear"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="次回調査年度"
              fullWidth
              type="text"
              required={false}
              validate={[
                // validateRule.number,
                // validateRule.maxLength(22),
              ]}
            />
          </Grid>
          <Grid key="previous_surveycode" item xs={12} sm={2}>
            <Field
              id="previous_surveycode"
              name="previous_surveycode"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="前回委託エリア"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'委託１'}</MenuItem>
              <MenuItem value={2}>{'委託２'}</MenuItem>
              <MenuItem value={3}>{'委託３'}</MenuItem>
            </Field>
          </Grid>
          {/* <Grid key="next_surveycode" item xs={12} sm={2}>
            <Field
              id="next_surveycode"
              name="next_surveycode"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="次回委託エリア"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'委託１'}</MenuItem>
              <MenuItem value={2}>{'委託２'}</MenuItem>
              <MenuItem value={3}>{'委託３'}</MenuItem>
            </Field>
          </Grid> */}
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="senroCode" item xs={12} sm={1}>
            <Field
              id="senroCode"
              name="senroCode"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="線路コード"
              fullWidth
              type="text"
              required={false}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid key="senroName" item xs={12} sm={3}>
            <Autocomplete
              ref={`autocomplete`}
              // freeSolo
              id="autocompleteSenroName"
              disableClearable
              options={autoCompleteItems.map((option) => option.senroMskn)}
              size='small'
              disabled={this.state.senroNameDisabled}
              fullWidth
              className="dntFields"
              // sx={{width: '320px'}}
              onBlur={this.handleSenroNameChange}
              renderInput={(params) => (
                <Field
                  id="senroName"
                  name="senroName"
                  component={renderTextField}
                  label="線路名"
                  required={false}
                  validate={[
                  ]}
                  {...params}
                />
              )}
            />
          </Grid>
          <Grid key="dntNo1" item xs={12} sm={1}>
            <Field
              id="dntNo1"
              name="dntNo1"
              component={renderTextField}
              className="dntFields"
              label="幹線"
              fullWidth
              type="text"
              required={false}
              // onChange={this.conditionChange}
              // sx={{width: '60px'}}
            />
          </Grid>
          <Grid key="dntNo2" item xs={12} sm={1}>
            <Field
              id="dntNo2"
              name="dntNo2"
              component={renderTextField}
              className="dntFields"
              label="第１分岐"
              fullWidth
              type="text"
              required={false}
              // onChange={this.conditionChange}
              // sx={{width: '60px'}}
            />
          </Grid>
          <Grid key="dntNo3" item xs={12} sm={1}>
            <Field
              id="dntNo3"
              name="dntNo3"
              component={renderTextField}
              className="dntFields"
              label="第２分岐"
              fullWidth
              type="text"
              required={false}
              // onChange={this.conditionChange}
              // sx={{width: '60px'}}
            />
          </Grid>
          <Grid key="dntNo4" item xs={12} sm={1}>
            <Field
              id="dntNo4"
              name="dntNo4"
              component={renderTextField}
              className="dntFields"
              label="第３分岐"
              fullWidth
              type="text"
              required={false}
              onChange={this.conditionChange}
              // sx={{width: '60px'}}
            />
          </Grid>
          <Grid key="bunki" item xs={12} sm={2}>
            <Field
              id="bunki"
              name="bunki"
              component={renderSelect}
              className="dntFields"
              label="分岐有無"
              fullWidth
              required={false}
              // onChange={this.conditionChange}
              sx={{width: '120px'}}
            >
              {/* {bunkiList} */}
              <MenuItem value={1}>{'分岐無'}</MenuItem>
              <MenuItem value={2}>{'分岐有'}</MenuItem>
            </Field>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="tdhknAddCd" item xs={12} sm={2}>
            <Field
              id="tdhknAddCd"
              name="tdhknAddCd"
              // variant="standard"
              component={renderSelect}
              className="fields"
              fullWidth
              label="都道府県"
              type="text"
              // sx={{width: '20%'}}
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={31}>{'鳥取県'}</MenuItem>
              <MenuItem value={32}>{'島根県'}</MenuItem>
              <MenuItem value={33}>{'岡山県'}</MenuItem>
              <MenuItem value={34}>{'広島県'}</MenuItem>
              <MenuItem value={35}>{'山口県'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="azatmApart" item xs={12} sm={4}>

            <Field
              id="azatmApart"
              name="azatmApart"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="住所"
              // sx={{width: '75%'}}
              fullWidth
              type="text"
              required={false}
              InputProps={{
                readOnly: false,
              }}
            />
          </Grid>
          {/* <Grid key="everyYearTs" item xs={12} sm={6}>
            <FormControl component="fieldset" className="formControl">
              <FormGroup row={true}>
                <Field className="checkbox"
                  id="everyYearTs"
                  name="everyYearTs"
                  component={renderCheckbox}
                  label="調査会社固定"
                  onChange={this._handleChangeCheckbox}
                  // isChecked="true"
                  validate={[]}
                  sx={{marginLeft: '20px'}}
                />
              </FormGroup>
            </FormControl>
          </Grid> */}
        </Grid>
      </React.Fragment>
    );
  };

  render() {
    const {classes,
      // generalPurposeMap,
      // reset,
      handleSubmit,
      // values,
      //  userInfo
    } = this.props;

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    // タブとタブパネルを生成
    // const tabElements = this._createTabElements();

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          footerBtn={footerBtn}>
          <CustomBreadcrumbs key="keyBreadcrumbs" items={this.state.transitionList}/>
          <Grid key="keyBFA10111GMsg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <PaperPart>
            <CustomAccordion title='検索条件' items={[this.renderCondition()]} defaultExpanded={true}/>
            {/*
            <Typography variant="h6" gutterBottom>&nbsp;</Typography>
            {[this.renderCondition()]}
            */}
            <Grid
              container
              justifyContent="right"
              alignItems="right"
            >
              <Grid key="clear" item>
                <NegativeButton
                  id="clear"
                  variant="contained"
                  startIcon={<RotateLeftIcon />}
                  className='button_list'
                  size="middle"
                  onClick={handleSubmit(this._reset)}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '20px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '4px'}} />
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Grid key="key1001List" item xs={12}>
              {this.renderTable()}
            </Grid>
          </Grid>
        </MainContainer>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  generalPurposeMap: PropTypes.object,
  orderList: PropTypes.array,
  history: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  order: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doGetOrderTypeList: PropTypes.func,
  doSetOrderId: PropTypes.func,
  doDeleteProprietyOrder: PropTypes.func,
  doClearOrderInfo: PropTypes.func,
  doSetStbType: PropTypes.func,
  doClearOrderList: PropTypes.func,
  doRetrieveOrder: PropTypes.func,
  doClearOrder: PropTypes.func,
  doSetReferenceMode: PropTypes.func,
  doSetOrderModifiedCondition: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
  change: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    orderList: state.attachorder.orderList,
    order: state.attachorder.order,
    // initialValues: {
    //   dntNo1: '123',
    //   dntNo2: '456',
    //   dntNo3: '789',
    //   hikikomiDnt: '123',
    //   keiyakuNo1: '',
    //   jigyousyo: '456',
    //   states: '2',
    // },
    initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doGetOrderTypeList: attachorderOperations.doGetOrderTypeList,
  doSetOrderId: attachorderOperations.doSetOrderId,
  doDeleteProprietyOrder: attachorderOperations.doDeleteProprietyOrder,
  doClearOrderInfo: attachorderOperations.doClearOrderInfo,
  doSetStbType: commonOperations.doSetStbType,
  doClearOrderList: attachorderOperations.doClearOrderList,
  doRetrieveOrder: attachorderOperations.doRetrieveOrder,
  doClearOrder: attachorderOperations.doClearOrder,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  doSetOrderModifiedCondition:
    attachorderOperations.doSetOrderModifiedCondition,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'SCA1008FORM';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);
